import React from 'react';
import {
  Box,
  Stepper,
  Step,
  StepLabel,
  StepButton,
  Typography,
  Tooltip,
} from '@mui/material';
import {
  useWorkflow,
  WORKFLOW_STEPS,
  STEP_LABELS,
  WorkflowStep,
} from '../../contexts/WorkflowContext';

const StepNavigation: React.FC = () => {
  const { currentStep, setStep } = useWorkflow();

  const activeStep = WORKFLOW_STEPS.indexOf(currentStep);

  const handleStepClick = (step: WorkflowStep) => () => {
    // In a real app, we might want to prevent jumping ahead if previous steps aren't complete
    // For now, allow free navigation for development/demo
    setStep(step);
  };

  return (
    <Box
      sx={{
        width: '100%',
        mb: 4,
        pt: 2,
        pb: 2,
        position: 'sticky',
        top: 0,
        zIndex: 100,
        bgcolor: 'background.paper',
        borderBottom: 1,
        borderColor: 'divider',
        boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
      }}
    >
      <Stepper nonLinear activeStep={activeStep} alternativeLabel>
        {WORKFLOW_STEPS.map((step, index) => {
          const label = STEP_LABELS[step];
          return (
            <Step key={step}>
              <StepButton onClick={handleStepClick(step)}>
                <StepLabel>
                  <Tooltip title={`Go to ${label}`}>
                    <Typography
                      variant="body2"
                      fontWeight={index === activeStep ? 'bold' : 'normal'}
                    >
                      {label}
                    </Typography>
                  </Tooltip>
                </StepLabel>
              </StepButton>
            </Step>
          );
        })}
      </Stepper>
    </Box>
  );
};

export default StepNavigation;
